import { Navigate } from "react-router-dom";
import { useAuth, hasRole } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, status } = useAuth();
  if (status === "loading") {
    return (
      <div className="flex h-screen items-center justify-center text-slate-500 text-sm" data-testid="auth-loading">
        Yükleniyor...
      </div>
    );
  }
  if (status !== "authed") {
    return <Navigate to="/giris" replace />;
  }
  if (roles && !hasRole(user, ...roles)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
